import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { ArkikWebComponentsModule } from '@core/modules';
import { TranslationPipeModule } from '@shared/pipes/translation-pipe.module';
import { ArkikDialogModule } from '../arkik-dialog/arkik-dialog.module';
import { PwaInstallInstructionsComponent } from './pwa-install-instructions.component';
import { IosPwaPromptComponent } from '../ios-pwa-animation/ios-pwa-animation';

@NgModule({
  declarations: [PwaInstallInstructionsComponent, IosPwaPromptComponent],
  imports: [CommonModule, A11yModule, ArkikWebComponentsModule, TranslationPipeModule, ArkikDialogModule],
})
export class PwaInstallInstructionsComponentModule {}
